import { SortOrder } from './utils/generateQueryParams'
import { ActionTrigger } from '../activityLog/activityLog.interface'

// Re-export ActionTrigger so other modules can import it from here
export { ActionTrigger }

export enum VerdictType {
  BYPASSED = 'bypassed',
  REDIRECTED = 'redirected',
  BLOCKED = 'blocked',
}

export enum GroupBy {
  ENDPOINT_ID = 'endpointId',
  CLIENT_ID = 'clientId',
  PROFILE_ID = 'profileId',
  ACTION = 'action',
  TRIGGER = 'trigger',
  TRIGGER_VALUE = 'triggerValue',
  SPOOF_TARGET = 'spoofTarget',
  QUESTION = 'question',
  PROTOCOL = 'protocol',
  STATUS_CODE = 'statusCode',
  RR_TYPE = 'rrType',
  SRC_COUNTRY = 'srcCountry',
  DST_COUNTRY = 'dstCountry',
  SRC_ISP = 'srcIsp',
  DST_ISP = 'dstIsp',
  SRC_ASN = 'srcAsn',
  DST_ASN = 'dstAsn',
}

export enum ActionType {
  BLOCKED = 0,
  BYPASSED = 1,
  SPOOF_IP = 2, // ip or hostname
  SPOOF_TAG = 3, // location
}

export type CommonParams = {
  startTime?: string
  endTime?: string
  /**
   * default to baselineEndTime - (endtime-starttime)
   */
  baselineStartTime?: string
  /**
   * defaults to startTime
   */
  baselineEndTime?: string
  region: string
  group?: string
  limit?: number
  action?: ActionType | ActionType[]
  clientId?: string | string[]
  endpointId?: string | string[]
  trigger?: ActionTrigger | ActionTrigger[]
  triggerValue?: string | string[]
  question?: string | string[]
  srcCountry?: string[]
  dstCountry?: string[]
  dstAsn?: number[]
  srcAsn?: number[]
  dstIsp?: string[]
  srcIsp?: string[]
  protocol?: string[]
  sortOrder?: SortOrder
  searchQuestion?: string
}

export interface AnalyticsTimeSeriesDataPoint {
  time: string
  count: Record<string, number>
}
export interface AnalyticsTimeSeriesData {
  startTime: string
  endTime: string
  granularity: TimeGranularity
  queries: AnalyticsTimeSeriesDataPoint[]
}

export enum TimeGranularity {
  DAY = 'day',
  HOUR = 'hour',
  MINUTE = 'minute',
}

export type Group = {
  group: string
  baseline: number
  current: number
}
export interface StatisticsTrendData {
  startTime: number
  endTime: number
  baselineStartTime: number
  baselineEndTime: number
  groups: Group[]
}

export type Count = {
  value: string
  count: number
}
export interface StatisticsCountByGroupData {
  startTime: number
  endTime: number
  counts?: Count[]
}

export interface StatisticsCountData {
  startTime: number
  endTime: number
  count: number
}

export interface DataAvailability {
  queryCutoffDate: string
  fields: {
    dstAsn: string
    protocol: string
    srcAsn: string
  }
}

export enum StatLevel {
  NO,
  SOME,
  FULL,
}

export interface StatEndpointInfo {
  PK: string
  title: string
  country_code?: string
}

export interface StatLevelInfo {
  PK: StatLevel
  title: string
}

export enum QueryFilterType {
  FILTERS = 'filters',
  SERVICES = 'services',
  LOCATIONS = 'locations',
  ALL = 'all',
}
